// 共享数据
let Store = {
  state: {
    name: "",
    path: "",
    AA: true,
    // 选中的产品
    actionProduct: {},
    // 比较的产品
    bijiaoProduct: [],
  },
  setName(name) {
    this.state.name = name;
    // console.log('set', this.state.name)
  },
  // 选中的导航
  setPath(val) {
    this.state.path = String(val);
    window.sessionStorage.setItem("path", String(val));
  },
  setActionProduct(val) {
    this.state.actionProduct = val;
  },
  //   选中或取消比较
  actionBiJiao(item) {
    let index = this.ifbijiao(item);
    if (index >= 0) {
      this.state.bijiaoProduct.splice(index, 1);
    } else {
      this.state.bijiaoProduct.push(item);
    }
  },
  // 是否已经在比较中
  ifbijiao(item) {
    return this.state.bijiaoProduct.indexOf(item);
  },
};
// 获取保存的数据 当前帖子
if (window.sessionStorage.getItem("path")) {
  Store.state.path = String(JSON.parse(window.sessionStorage.getItem("path")));
}

export default Store;
